import React, { useState, useEffect } from "react";
import axios from "axios";

import Header from "./Header";
import ResearcherCard from "./ResearcherCard";
import "./Research_rihes_th.css";

const Research_rihes_th = () => {
  const xURL = "https://research.rihes.cmu.ac.th/api/";

  // State สำหรับหัวหน้าศูนย์
  const [dataSource, setDataSource] = useState([]);
  const [dataSource2, setDataSource2] = useState([]);
  const [dataSource3, setDataSource3] = useState([]);
  const [dataSource4, setDataSource4] = useState([]);
  const [dataSource5, setDataSource5] = useState([]);
  const [dataSource6, setDataSource6] = useState([]);
  const [dataSource7, setDataSource7] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // State สำหรับ units
  const [expandedUnits, setExpandedUnits] = useState(
    new Set([1, 2, 3, 4, 5, 6])
  );

  const pageMap = {
    SHSR: "4",
    HSRC: "2",
    PROCRC: "1"
  };

  const unitsMap = {
    HSRC: [
      { id: 1, name: "หน่วยวิจัยอนามัยสิ่งแวดล้อมและอาชีวอนามัย" },
      { id: 2, name: "หน่วยวิจัยพฤติกรรมสุขภาพ" },
      { id: 3, name: "หน่วยวิจัยโรคติดเชื้อและชีววิทยาศาสตร์โมเลกุล" },
      { id: 4, name: "หน่วยวิจัยโรคไม่ติดต่อเรื้อรัง" },
      { id: 5, name: "หน่วยวิจัยและทดสอบทางโภชนาการ" },
      { id: 6, name: "หน่วยวิจัยสารเสพติด" }
    ],
    PROCRC: [{ id: 1, name: "นักวิจัยอาวุโส" }, { id: 2, name: "แพทย์" }],
    SHSR: [
      { id: 1, name: "รองหัวหน้าสำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ" },
      { id: 2, name: "อาจารย์" }
    ]
  };

  const [pages, setPages] = useState("HSRC");
  const [language, setLanguage] = useState("th");
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const p = url.searchParams.get("pages") || "HSRC";
    setPages(p);

    // อ่าน language จาก localStorage
    const savedLang = localStorage.getItem("language") || "th";
    setLanguage(savedLang);

    const center = pageMap[p];

    if (center) {
      fetchData(center, p);
    }

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const units = unitsMap[pages] || unitsMap.HSRC;

  const dataSourceMap = {
    HSRC: {
      1: dataSource2,
      2: dataSource3,
      3: dataSource4,
      4: dataSource5,
      5: dataSource6,
      6: dataSource7
    },
    PROCRC: {
      1: dataSource2, // อาวุโส
      2: dataSource3 // แพทย์
    },
    SHSR: {
      1: dataSource2,
      2: dataSource3
    }
  }[pages] || {
    1: dataSource2,
    2: dataSource3,
    3: dataSource4,
    4: dataSource5,
    5: dataSource6,
    6: dataSource7
  };

  const fetchData = async (center, p) => {
    setLoading(true);
    setError(null);
    try {
      const result = await axios.post(`${xURL}getResearch_rihes`, {
        center: center,
        order: 2
      });

      //   console.error(result.data);
      if (result.data && Array.isArray(result.data)) {
        const Tb1 = [],
          Tb2 = [],
          Tb3 = [],
          Tb4 = [],
          Tb5 = [],
          Tb6 = [],
          Tb7 = [];
        const tbArrays = { Tb1, Tb2, Tb3, Tb4, Tb5, Tb6, Tb7 };

        // Mapping idx ranges to table arrays
        const rangeMap =
          p === "PROCRC"
            ? [
                { table: "Tb2", min: 1, max: 2 },
                { table: "Tb3", min: 0, max: 0 },
                { table: "Tb3", min: 3, max: 8 }
              ]
            : p === "SHSR"
              ? [
                  { table: "Tb2", min: 1, max: 1 },
                  { table: "Tb3", min: 2, max: 10 } // SHSR: เก็บทั้งหมดใน Tb2
                ]
              : [
                  { table: "Tb2", min: 0, max: 8 },
                  { table: "Tb3", min: 9, max: 12 },
                  { table: "Tb4", min: 13, max: 18 },
                  { table: "Tb5", min: 19, max: 23 },
                  { table: "Tb6", min: 24, max: 27 },
                  { table: "Tb7", min: 28, max: 30 }
                ];

        result.data.forEach((item, idx) => {
          // ✓ แยก expertise: ตัด | นำหน้า และแยกด้วย |, หรือ space
          let expertise = [];
          if (item.researcher_expertise_thai_new) {
            expertise = item.researcher_expertise_thai_new
              .trim() // ตัด whitespace นำหน้า/หลัง
              .replace(/^\|/, "") // ตัด | นำหน้า
              .trim() // ตัด whitespace อีกครั้ง
              .split(/\|/) // แยกด้วย |
              .filter(e => e.trim().length > 0) // ลบ empty strings
              .map(e => e.trim()); // ตัด whitespace แต่ละส่วน
          } else {
            expertise = ["-"];
          }

          // แก้ไข position: position + position_aca ถ้ามี positionex ให้เพิ่ม | positionex
          let positionStr = `${item.position || ""} ${item.position_aca ||
            ""}`.trim();
          if (item.positionex) {
            positionStr = `${positionStr} | ${item.positionex}`;
          }

          const researcherObj = {
            id: item.id,
            name: item.name,
            position: positionStr,
            expertise: expertise,
            image: `${xURL}file_research/${item.picname}`
          };

          // Head researcher

          if (p === "PROCRC") {
            if (idx === 0) {
              Tb1.push(researcherObj);
            }
          } else if (p === "SHSR") {
            if (idx === 0) {
              Tb1.push(researcherObj); // SHSR หัวหน้า
            }
          } else {
            if (idx === 13) {
              Tb1.push(researcherObj); // HSRC หัวหน้า
            }
          }

          // Distribute to units
          rangeMap.forEach(({ table, min, max }) => {
            if (idx >= min && idx <= max) {
              tbArrays[table].push(researcherObj);
            }
          });
        });

        // console.error(Tb1);
        setDataSource(Tb1);
        setDataSource2(Tb2);
        setDataSource3(Tb3);
        setDataSource4(Tb4);
        setDataSource5(Tb5);
        setDataSource6(Tb6);
        setDataSource7(Tb7);
      } else {
        setDataSource([]);
        setDataSource2([]);
        setDataSource3([]);
        setDataSource4([]);
        setDataSource5([]);
        setDataSource6([]);
        setDataSource7([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
      setDataSource([]);
      setDataSource2([]);
      setDataSource3([]);
      setDataSource4([]);
      setDataSource5([]);
      setDataSource6([]);
      setDataSource7([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleUnit = unitId => {
    const newExpanded = new Set(expandedUnits);
    if (newExpanded.has(unitId)) {
      newExpanded.delete(unitId);
    } else {
      newExpanded.add(unitId);
    }
    setExpandedUnits(newExpanded);
  };

  return (
    <div>
      <Header />

      {/* หัวหน้าศูนย์วิจัย */}
      <div className="header-researchers-container">
        {loading && <p className="loading">กำลังโหลดข้อมูล...</p>}
        {error &&
          <p className="error">
            เกิดข้อผิดพลาด: {error}
          </p>}
        {!loading && !error && dataSource.length > 0
          ? dataSource.map(researcher =>
              <ResearcherCard
                key={researcher.id}
                {...researcher}
                language={language}
                onViewMore={() =>
                  (window.location.href = `/Research_detail_th?rid=${researcher.id}`)}
              />
            )
          : !loading && !error
            ? <p className="no-data">ไม่มีข้อมูลนักวิจัย</p>
            : null}
      </div>

      {/* หน่วยวิจัยต่างๆ */}
      <div className="units-container">
        {units.map(unit =>
          <div key={unit.id} className="unit-section">
            <button className="unit-header" onClick={() => toggleUnit(unit.id)}>
              <h2>
                {unit.name}
              </h2>
              <span
                className={`toggle-icon ${expandedUnits.has(unit.id)
                  ? "open"
                  : ""}`}
              >
                ▼
              </span>
            </button>

            {expandedUnits.has(unit.id) &&
              <div className="unit-content">
                <div className="researchers-container">
                  {dataSourceMap[unit.id] && dataSourceMap[unit.id].length > 0
                    ? dataSourceMap[unit.id].map(researcher =>
                        <ResearcherCard
                          key={researcher.id}
                          {...researcher}
                          language={language}
                          onViewMore={() =>
                            (window.location.href = `/Research_detail_th?rid=${researcher.id}`)}
                        />
                      )
                    : <p className="no-data">ยังไม่มีข้อมูลนักวิจัย</p>}
                </div>
              </div>}
          </div>
        )}
      </div>

      {/* Scroll to top button */}
      {showScrollTop &&
        <button className="scroll-to-top" onClick={scrollToTop}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
          </svg>
        </button>}
    </div>
  );
};

export default Research_rihes_th;
